export { Slider, renderSlider, useSlider } from './components/Slider/index';
export type { SliderSlots, SliderProps, SliderState } from './components/Slider/index';
